<script setup>
import { onMounted, ref, defineProps } from "vue";
import DevicePanel from "@/views/ela/components/DevicePanel.vue";
const props = defineProps({
  data: Object,
});

const expanded = ref(false);
onMounted(() => {
  expanded.value = props.data.expanded;
});

import { useDisplay } from "vuetify";

const { mobile } = useDisplay();
</script>

<template>
  <v-card rounded="lg" elevation="1" class="ml-1 mt-2 mb-1" height="95%">
    <template v-if="!expanded">
      <v-card-title @click="expanded = !expanded"
        ><v-icon>mdi-chevron-right</v-icon>{{ data.sectionTitle }}</v-card-title
      >
    </template>
    <template v-else>
      <v-card-title @click="expanded = !expanded"
        ><v-icon>mdi-chevron-down</v-icon>{{ data.sectionTitle }}</v-card-title
      >
      <v-card-text>
        <v-row>
          <v-col>
            <v-table density="compact">
              <tbody>
                <tr v-for="field in data.fields" :key="field">
                  <template v-if="!field.type">
                    <th class="pl-10 font-weight-medium">{{ field.name }}</th>
                    <td class="text-medium-emphasis text-center">
                      {{ field.value }}
                    </td>
                  </template>
                  <template v-if="field.type == 'subTable'">
                    <td colspan="2">
                      <v-table>
                        <thead>
                          <tr>
                            <th v-for="header in field.cols" :key="header">
                              {{ header }}
                            </th>
                          </tr>
                          <tr v-for="value in field.values" :key="value">
                            <td v-for="header in field.cols" :key="header">
                              {{ value[header] }}
                            </td>
                          </tr>
                        </thead>
                      </v-table>
                    </td>
                  </template>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </v-card>
</template>
